class NavAccordion extends HTMLElement {
	constructor() {
		super()
		this.trigger = this.querySelector("accordion-title")
		this.content = this.querySelector("accordion-content")
	}

	isDesktop = () => {
		return false
	}

	toggleAccordion = () => {
		if (this.isDesktop() && this.hasAttribute("data-nav-drawer-trigger")) {
			const drawerId = this.getAttribute("data-nav-drawer-id")
			const drawer = document.querySelector(`nav-drawer[data-nav-drawer-id="${drawerId}"]`)
			if (drawer) {
				drawer.openNavDrawer()
			}
			return
		}

		if (this.hasAttribute("open")) {
			this.removeAttribute("open")
			this.content.style.maxHeight = 0
		} else {
			this.setAttribute("open", "open")
			this.content.style.maxHeight = this.content.scrollHeight + "px"

			setTimeout(() => {
				const parentAccordion = this.closest("[data-parent]")
				if (parentAccordion && parentAccordion.hasAttribute("open")) {
					const parentContent = parentAccordion.querySelector("accordion-content")
					parentContent.style.maxHeight = "9999px"
				}
			}, 50)
		}
	}

	init = () => {
		if (this.trigger) {
			this.trigger.addEventListener("click", e => {
				this.toggleAccordion()
			})
		}
	}

	connectedCallback() {
		this.init()
	}
}

customElements.define("nav-accordion", NavAccordion)
class NavDrawer extends HTMLElement {
	constructor() {
		super()
		this.id = this.getAttribute("data-nav-drawer-id")
		this.close = this.querySelector(`.nav-drawer-close`)
		this.overlay = this.querySelector(`.nav-overlay`)
		this.trigger = document.querySelectorAll(
			`[data-nav-drawer-trigger][data-nav-drawer-id="${this.id}"]`
		)
		this.isAnimating = false
	}

	closeNavDrawer = e => {
		if (e && typeof e.preventDefault === "function") e.preventDefault()

		// FIX: Check if THIS specific drawer is closed, not the global body
		if (this.isAnimating || !this.classList.contains("active")) return

		if (this) {
			this.isAnimating = true

			this.classList.remove("reveal")
			this.classList.remove("active")
			this.classList.remove("finished")

			setTimeout(() => {
				// Only remove the body locks if we are closing the very last drawer
				// (In case multiple are open at the same time)
				const activeDrawers = document.querySelectorAll("nav-drawer.active")
				if (activeDrawers.length === 0) {
					document.body.classList.remove("nav-drawer-open")

					const savedScrollY = document.body.getAttribute("data-scroll-y") || "0"

					document.body.style.position = ""
					document.body.style.top = ""
					document.body.style.width = ""
					document.body.style.overflowY = ""

					window.scrollTo({
						top: parseInt(savedScrollY),
						left: 0,
						behavior: "instant"
					})
				}

				this.classList.add("hide-drawer")
				this.isAnimating = false
			}, 600)
		}
	}

	openNavDrawer = e => {
		if (e && typeof e.preventDefault === "function") e.preventDefault()

		// FIX: Check if THIS specific drawer is open, not the global body
		if (this.isAnimating || this.classList.contains("active")) return

		if (this) {
			this.isAnimating = true

			this.classList.remove("hide-drawer")
			document.body.classList.add("nav-drawer-open")

			// Only capture and lock the scroll if it isn't already locked by another drawer
			if (!document.body.style.position) {
				const currentScrollY = window.scrollY
				document.body.setAttribute("data-scroll-y", currentScrollY)

				document.body.style.position = "fixed"
				document.body.style.top = `-${currentScrollY}px`
				document.body.style.width = "100%"
				document.body.style.overflowY = "scroll"
			}

			setTimeout(() => {
				this.classList.add("active")
				this.classList.add("reveal")
			}, 300)

			setTimeout(() => {
				this.classList.add("finished")
				this.isAnimating = false
			}, 800)
		}
	}

	init = () => {
		if (this.close) {
			this.close.addEventListener("click", this.closeNavDrawer)
		}
		if (this.overlay) {
			this.overlay.addEventListener("click", this.closeNavDrawer)
		}
		if (this.trigger.length > 0) {
			this.trigger.forEach(trigger => {
				trigger.addEventListener("click", this.openNavDrawer)
			})
		}
	}

	connectedCallback() {
		this.init()
	}
}

customElements.define("nav-drawer", NavDrawer)
class NavBannerCarousel extends HTMLElement {
    constructor() {
        super()
        this.carousel = this.querySelector(".nav-drawer__banner-carousel")
        this.slides = this.querySelectorAll(".nav-drawer__banner-slide")
        this.prevBtn = this.querySelector(".nav-drawer__banner-btn--prev")
        this.nextBtn = this.querySelector(".nav-drawer__banner-btn--next")
        this.dots = this.querySelectorAll(".nav-drawer__banner-dot")

        this.currentIndex = 0
        this.totalSlides = this.slides.length

        // Autoplay properties
        this.autoplayInterval = 5000 // Time in milliseconds (5 seconds)
        this.autoplayTimer = null
        this.userInteracted = false // Flag to check if user took control
        
        // Scroll optimization properties
        this.scrollTimeout = null
        this.isProgrammaticScroll = false
    }

    connectedCallback() {
        if (this.totalSlides > 1) {
            this.init()
        }
    }

    init() {
        // Event listeners for Prev / Next arrows
        if (this.prevBtn) {
            this.prevBtn.addEventListener("click", () => {
                this.handleUserInteraction()
                this.navigate(-1)
            })
        }
        if (this.nextBtn) {
            this.nextBtn.addEventListener("click", () => {
                this.handleUserInteraction()
                this.navigate(1)
            })
        }

        // Event listeners for the Dots
        if (this.dots.length > 0) {
            this.dots.forEach(dot => {
                dot.addEventListener("click", e => {
                    this.handleUserInteraction()
                    const index = parseInt(e.currentTarget.getAttribute("data-index"))
                    this.goToSlide(index)
                })
            })
            // Set initial active dot
            this.updateDots()
        }

        // --- NEW: Optimized Swiping/Scroll Tracker ---
        if (this.carousel) {
            this.carousel.addEventListener('scroll', () => {
                // Ignore scroll events triggered by clicking arrows/dots
                if (this.isProgrammaticScroll) return;

                // Debounce to prevent lag: Wait 50ms after scroll to calculate
                if (this.scrollTimeout) clearTimeout(this.scrollTimeout);
                
                this.scrollTimeout = setTimeout(() => {
                    const slideWidth = this.slides[0].clientWidth;
                    const newIndex = Math.round(this.carousel.scrollLeft / slideWidth);
                    
                    if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.totalSlides) {
                        this.currentIndex = newIndex;
                        this.updateDots();
                        this.handleUserInteraction(); // Stop autoplay if swiped manually
                    }
                }, 50); 
            }, { passive: true }); // Passive true makes native scrolling buttery smooth
        }

        // Hover events for the entire carousel to pause/resume
        this.addEventListener("mouseenter", () => {
            this.stopAutoplay()
        })

        this.addEventListener("mouseleave", () => {
            // Only resume autoplay if the user hasn't clicked anything yet
            if (!this.userInteracted) {
                this.startAutoplay()
            }
        })

        // Kick off the autoplay when the element loads
        this.startAutoplay()
    }

    // --- Autoplay Logic ---
    startAutoplay() {
        this.stopAutoplay() // Safety check to prevent multiple timers running at once
        this.autoplayTimer = setInterval(() => {
            this.navigate(1) // Move forward 1 slide
        }, this.autoplayInterval)
    }

    stopAutoplay() {
        if (this.autoplayTimer) {
            clearInterval(this.autoplayTimer)
        }
    }

    handleUserInteraction() {
        this.userInteracted = true
        this.stopAutoplay()
    }
    // --- End Autoplay Logic ---

    navigate(direction) {
        // This math logic ensures we loop perfectly backward and forward
        this.currentIndex = (this.currentIndex + direction + this.totalSlides) % this.totalSlides
        this.scrollToCurrent()
    }

    goToSlide(index) {
        this.currentIndex = index
        this.scrollToCurrent()
    }

    scrollToCurrent() {
        // Prevent scroll tracker from firing while we programmatically scroll
        this.isProgrammaticScroll = true; 
        
        // Calculate the width of one slide dynamically
        const slideWidth = this.slides[0].clientWidth

        // Scroll the UL element to the correct position
        this.carousel.scrollTo({
            left: slideWidth * this.currentIndex,
            behavior: "smooth"
        })

        this.updateDots()
        
        // Release the scroll block after smooth scroll finishes
        setTimeout(() => {
            this.isProgrammaticScroll = false;
        }, 600);
    }

    updateDots() {
        if (!this.dots.length) return

        this.dots.forEach((dot, index) => {
            if (index === this.currentIndex) {
                dot.classList.add("is-active")
                dot.setAttribute('aria-current', 'true') // Theme fallback attribute
            } else {
                dot.classList.remove("is-active")
                dot.removeAttribute('aria-current')
            }
        })
    }
}

customElements.define("nav-banner-carousel", NavBannerCarousel)